'use client'

/**
 * UI component
 * should be removed to a shared common repository
 */

import React from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import clsx from 'clsx'

export type CheckboxInputProps = {
  /**
   * If true, the component is checked
   */
  checked?: boolean
  className?: string
  classes?: {
    root?: string
    checkbox?: string
    label?: string
  }
  disabled?: boolean
  /**
   * The label content
   */
  label?: React.ReactNode
  name?: string
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  readOnly?: boolean
  /**
   * The value of the component
   */
  value?: string
}

export default function CheckboxInput(props: CheckboxInputProps) {
  const { checked, className, classes, disabled, label, name, onChange, readOnly = false, value } = props

  return (
    <FormControlLabel
      classes={{
        root: clsx('items-start m-0', className, classes?.root),
        label: clsx('ml-3 text-sm leading-6', classes?.label),
      }}
      control={
        <div className="flex h-6 items-center">
          <input
            className={clsx('h-4 w-4 form-checkbox rounded border-gray-300 text-primary focus:ring-0 focus:ring-offset-0', classes?.checkbox)}
            checked={checked}
            disabled={disabled}
            id={name}
            name={name}
            onChange={!readOnly ? onChange : undefined}
            type="checkbox"
            value={value}
          />
        </div>
      }
      label={label || ''}
    />
  )
}
